<template>
  <div>

    <v-text-field
      class="mt-4 white medium-density inline-error"
      outlined persistent-placeholder
      :label="`Location name${required ? ' *' : ''}`"
      :disabled="disabled"
      :rules="[
        v => !required || !!v || 'Required',
        v => ((v || '').length <= 200) || 'Too long'
      ]"
      v-model="event.location"
    />

    <v-checkbox
      class="mt-4 mb-0 pt-0"
      label="Include address / map link" hide-details
      :disabled="disabled"
      v-model="showAddress"
    />
    <v-expand-transition>
      <div v-if="showAddress" class="ml-8">
        <v-textarea
          class="mt-4 white inline-error"
          label="Address" outlined persistent-placeholder no-resize rows="2"
          :disabled="disabled"
          :rules="[ v => ((v || '').length <= 500) || 'Too long' ]"
          v-model="event.address"
          @input="tryAutoLink"
        />
        <v-checkbox
          class="mt-4 pt-0"
          label="Auto-generate map link" hide-details
          :disabled="disabled || !event.address"
          :input-value="!!event.address && autoLink"
          @change="v => { autoLink = v; tryAutoLink(); }"
        />
        <v-text-field
          key="map-link"
          class="mt-4 white inline-error"
          outlined persistent-placeholder placeholder="http…" label="Map link"
          :disabled="disabled"
          :rules="[ validateURL ]"
          v-model="event.url_map"
          @input="autoLink = false"
        >
          <template v-slot:append>
            <v-btn
              color="primary" icon target="_blank"
              :disabled="!event.url_map || (validateURL(event.url_map) != true)"
              :href="event.url_map"
              @click="openURL(event.url_map)"
            >
              <v-icon v-html="mdiOpenInNew" />
            </v-btn>
          </template>
        </v-text-field>
      </div>
    </v-expand-transition>

    <v-checkbox
      class="mt-4 mb-0 pt-0"
      label="Include virtual event link" hide-details
      :disabled="disabled"
      v-model="showVirtual"
    />
    <v-expand-transition>
      <div v-if="showVirtual" class="ml-8">
        <v-text-field
          key="virtual-event-link"
          class="mt-4 white inline-error"
          outlined persistent-placeholder placeholder="http…" label="Virtual event link *"
          :disabled="disabled"
          :rules="[ v => !!v || 'Required', validateURL ]"
          v-model="event.url_virtual"
        >
          <template v-slot:append>
            <v-btn
              class="mr-n1"
              color="primary" icon target="_blank"
              :disabled="!event.url_virtual || (validateURL(event.url_virtual) != true)"
              :href="event.url_virtual"
              @click="openURL(event.url_virtual)"
            >
              <v-icon v-html="mdiOpenInNew" />
            </v-btn>
          </template>
        </v-text-field>
      </div>
    </v-expand-transition>

  </div>
</template>


<script>
import { buildMapLink } from '@/utils/event-location.js';
import { mdiOpenInNew } from '@mdi/js';

export default {
  name: 'event-location-form',

  props: [ 'event', 'disabled', 'required' ],

  data() {
    const { address, url_map, url_virtual } = this.event;
    return {
      autoLink: false,
      showAddress: !!(address || url_map),
      showVirtual: !!url_virtual
    };
  },

  created() {
    Object.assign(this, { mdiOpenInNew });
  },

  methods: {
    validateURL(v) {
      if (v && !v.startsWith('http://') && !v.startsWith('https://'))
        return `Should start with 'http'`;
      return true;
    },

    openURL(url) {
      open(url, '_blank').focus();
    },

    tryAutoLink() {
      const v = this.event.address;
      if (this.autoLink)
        this.event.url_map = v ? buildMapLink(v) : null;
    }
  },

  watch: {
    event: {
      immediate: true,
      handler(v) {
        if (v.address && (v.url_map == buildMapLink(v.address)))
          this.autoLink = true;
      }
    },

    showAddress(v) {
      if (!v) {
        this.event.address = null;
        this.event.url_map = null;
      }
    },

    showVirtual(v) {
      if (!v) {
        this.event.url_virtual = null;
      }
    }
  }
}
</script>
